/**
 * Opens or saves a file that has to be fetched with the admin login, so it cannot be a plain link.
 * The tab is opened before the fetch: one opened after an await counts as a popup and is blocked.
 */
export async function openFetchedFile(fetchBlob, fileName, download = false) {
  const tab = download ? null : window.open("", "_blank");
  try {
    const blob = await fetchBlob();
    const url = URL.createObjectURL(blob);
    if (download) {
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "document";
      link.click();
    } else if (tab) {
      tab.location.href = url;
    } else {
      window.open(url, "_blank");
    }
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    tab?.close();
    throw error;
  }
}
